import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {formValueSelector, reduxForm} from 'redux-form';
import {Button, Col, Row} from "reactstrap";
import {ff, form} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import CustomCheckboxField from "../components/CustomCheckboxField";
import * as EnumFormaDoruceniNotifikace from "../api/gen/cgo/EnumFormaDoruceniNotifikace";
import * as EnumFormaDoruceniNotifikaceInfo from "../api/EnumFormaDoruceniNotifikaceInfo";
import * as EnumStavObjednavkaNotifikace from "../api/gen/cgo/EnumStavObjednavkaNotifikace";
import * as EnumStavObjednavkaNotifikaceInfo from "../api/EnumStavObjednavkaNotifikaceInfo";
import * as EnumUdalostNotifikace from "../api/gen/cgo/EnumUdalostNotifikace";
import * as EnumUdalostNotifikaceInfo from "../api/EnumUdalostNotifikaceInfo";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {Tooltip} from 'react-tippy';
import {withTranslation, WithTranslation} from "react-i18next";

const {Form, FormActions, FormBody} = form;

/**
 * Formulář pro tvorbu/úpravu notifikací.
 */
class NotifikaceForm extends Component<WithTranslation> {

    static formName = 'NotifikaceForm';

    static propTypes = {
        notifikaceHelp: PropTypes.array.isRequired, // pole NotifikaceHelpVO
    };

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (!values.stavObjednavka && values.udalostNotifikace === EnumUdalostNotifikace.ZMENA_STAV) {
            errors.stavObjednavka = t('validation.order_state_required', {state: EnumUdalostNotifikaceInfo.getCaption(EnumUdalostNotifikace.ZMENA_STAV, t)});
        }
        if (!values.formaDoruceni) {
            errors.formaDoruceni = t('order.delivery_method_required');
        }
        return errors;
    };

    state = {
        tooltips: {},
        lastFocusedElement: null,
    };

    // setCursorPosition = (element, position) => {
    //     if (element) {
    //         if(element.createTextRange) {
    //             const range = element.createTextRange();
    //             range.move('character', position);
    //             range.select();
    //         } else {
    //             if (element.selectionStart) {
    //                 element.focus();
    //                 console.log("Setting selection to", position);
    //                 element.setSelectionRange(position, position);
    //             } else {
    //                 element.focus();
    //             }
    //         }
    //     }
    // };

    showTooltip = (id) => {
        const {lastFocusedElement} = this.state;
        const newState = {...this.state.tooltips};
        newState[id] = true;
        this.setState({tooltips: newState});
        setTimeout(() => {
            const newState = {...this.state.tooltips};
            newState[id] = false;
            this.setState({tooltips: newState});
        }, 1000);
        if (lastFocusedElement) {
            const value = lastFocusedElement.value;
            const position = lastFocusedElement.selectionEnd;
            const newValue = [value.slice(0, position), id, value.slice(position)].join('');
            lastFocusedElement.focus();
            this.props.change(lastFocusedElement.name, newValue);
            // tohle nefunguje, jelikož samotná změna proběhne až po tomhle
            // this.setCursorPosition(lastFocusedElement, position);
        }
    };

    updateLastFocus = (event) => {
        if (event.target) {
            this.setState({lastFocusedElement: event.target});
        }
    };

    render() {
        const {onClose, submitting, handleSubmit, notifikaceHelp, interniEmailNotifikace, t} = this.props;
        const {tooltips} = this.state;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <Row>
                    <Col sm={7}>
                        <ff.ObjectSuggest
                            label={t('labels.event')}
                            name="udalostNotifikace"
                            dropdown={true}
                            removable={false}
                            getItemValue={(item) => item ? EnumUdalostNotifikaceInfo.getCaption(item, t) : ""}
                            renderSuggestion={item => item ? EnumUdalostNotifikaceInfo.getCaption(item, t) : ""}
                            items={EnumUdalostNotifikace.values}
                            disabled={submitting}
                            required
                        />
                        <ff.ObjectSuggest
                            label={t('labels.state')}
                            name="stavObjednavka"
                            dropdown={true}
                            removable={false}
                            getItemValue={(item) => item ? EnumStavObjednavkaNotifikaceInfo.getCaption(item, t) : ""}
                            renderSuggestion={item => item ? EnumStavObjednavkaNotifikaceInfo.getCaption(item, t) : ""}
                            items={EnumStavObjednavkaNotifikace.values}
                            disabled={submitting}
                        />
                        <ff.ObjectSuggest
                            label={t('labels.delivery_form')}
                            name="formaDoruceni"
                            dropdown={true}
                            removable={false}
                            getItemValue={(item) => item ? EnumFormaDoruceniNotifikaceInfo.getCaption(item, t) : ""}
                            renderSuggestion={item => item ? EnumFormaDoruceniNotifikaceInfo.getCaption(item, t) : ""}
                            items={EnumFormaDoruceniNotifikace.values}
                            disabled={submitting}
                            required
                        />
                        <ff.String label={t('sender_email')} name="emailOdesilatel" disabled={submitting} onFocus={this.updateLastFocus}/>
                        <ff.String label={t('addressee_email')} name="emailAdresat" disabled={submitting} onFocus={this.updateLastFocus}/>
                        <ff.String label={t('email_subject')} name="emailPredmet" disabled={submitting} onFocus={this.updateLastFocus}/>
                        <ff.Textarea label={t('email_body')} name="emailTelo" disabled={submitting} onFocus={this.updateLastFocus}/>
                        <ff.String label={t('sms_addressee')} name="adresatSms" disabled={submitting || interniEmailNotifikace} onFocus={this.updateLastFocus}/>
                        <ff.Textarea label={t('sms_text')} name="textSms" disabled={submitting || interniEmailNotifikace} onFocus={this.updateLastFocus}/>
                        <CustomCheckboxField label={t('customer_wrote_down')} name="zapsalZakaznik" disabled={submitting}/>
                        <CustomCheckboxField label={t('operator_wrote_down')} name="zapsalOperator" disabled={submitting}/>
                        <CustomCheckboxField label={t('attach_pdf')} name="prilozitPdf" disabled={submitting}/>
                        <CustomCheckboxField label={t('labels.inactive')} name="neaktivni" disabled={submitting}/>
                        <CustomCheckboxField label={t('internal_email_notification')} name="interniEmailNotifikace" disabled={submitting}/>
                    </Col>
                    <Col sm={5}>
                        <h2>{t('representative_characters')}</h2>
                        <p>{t('representative_characters_copy')}</p>
                        <Row className={"p-3"}>
                            {notifikaceHelp.concat().sort((a,b) => a.zastupnyKod.localeCompare(b.zastupnyKod)).map((help) => {
                                return <Col xs={12} md={6} lg={4} className={"p-0"} key={help.zastupnyKod}>
                                    <Tooltip title="Zkopírováno" trigger="manual" open={tooltips[help.zastupnyKod]}>
                                        <CopyToClipboard text={help.zastupnyKod}>
                                            <Button type="button" title={`${help.napoveda}`} onClick={this.showTooltip.bind(this, help.zastupnyKod)}
                                                    size="sm" className={`w-100 ${help.zastupnyKod.startsWith("{ukon") ? "flex-last" : ""}`}>
                                                {help.zastupnyKod}
                                            </Button>
                                        </CopyToClipboard>
                                    </Tooltip>
                                </Col>
                            })}
                        </Row>
                    </Col>
                </Row>
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

const selector = formValueSelector(NotifikaceForm.formName);

const mapStateToProps = state => ({
    interniEmailNotifikace: selector(state, "interniEmailNotifikace"),
});

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: NotifikaceForm.formName,
    validate: NotifikaceForm.validate,
})(NotifikaceForm)));
